import React, { useState, useEffect } from 'react'
import { Paper, Button, Typography, Step, Stepper, StepLabel, CircularProgress, Divider, CssBaseline } from '@material-ui/core'
import {Link, useHistory} from 'react-router-dom'
import { commerce } from '../../../lib/commerce'

import useStyles from './style'
import AddressForm from '../AddressForm'
import PaymentForm from '../PaymentForm'

const steps = ['Shipping address', 'Payment details']

const Checkout = ({ cart,order, handleCaptureCheckout, error,refreshCart }) => {
  const [ activeStep, setActiveStep ] = useState(0)
  const [ checkoutToken, setCheckoutToken ] = useState(null)
  const [ shippingData, setShippingData ] = useState({})
  const [isFinished, setIsFinished] = useState(false)
  const classes = useStyles()
  const history = useHistory()

  useEffect(() => {
    const generateToken = async () => {
      try {
        const token = await commerce.checkout.generateToken(cart.id, { type: 'cart' })
        // console.log(token)
        setCheckoutToken(token)
      } catch (error) {
        history.pushState('/')
        console.log(error)
      }
    }
    generateToken()
  }, [cart])

  const nextStep = () => setActiveStep(activeStep + 1)
  const backStep = () => setActiveStep(activeStep - 1)

  const next = (data) => {
    setShippingData(data)

    nextStep()
  }

  const timeout = () => {
    setTimeout(() => {
      setIsFinished(true)
      refreshCart()
    }, 3000);
  }

  let Confirmation = () => order.customer ? (
    <>
      <div>
        <Typography variant="h5"> Thank you for your purchase, {order.customer.fistname} {order.customer.lastname}</Typography>
        <Divider className={classes.divider}/>
        <Typography variant="subtitle2">Order ref: {order.customer_reference}</Typography>
      </div>
      <br/>
      <Button component={Link} to="/" variant="outlined" type="button">Back to home</Button>
    </>
  ) : isFinished ? (
    <>
      <div>
        <Typography variant="h5"> Thank you for your purchase</Typography>
        <Divider className={classes.divider}/>
      </div>
      <br/>
      <Button component={Link} to="/" variant="outlined" type="button">Back to home</Button>
    </>
  ) : (
    <div className={classes.spinner}>
      <CircularProgress />
    </div>
  )

  if(error) {
    <>
      <Typography variant="h5">Error: {error}</Typography>
      <br/>
      <Button component={Link} to="/" variant="outlined" type="button">Back to home</Button>
    </>
  }

  const Form = () => activeStep === 0
    ? <AddressForm checkoutToken={checkoutToken} next={next}/>
    : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} handleCaptureCheckout={handleCaptureCheckout} timeout={timeout}/>
    // console.log(checkoutToken)
  return (
    <>
    <CssBaseline/>
      <div className={classes.toolbar} />
      <main className={classes.layout}>
        <Paper className={classes.paper} elevation={3}>
          <Typography variant="h4" align="center">Checkout</Typography>
          <Stepper className={classes.stepper} activeStep={activeStep}>
            {steps.map(step => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? <Confirmation/> : checkoutToken && <Form/>}
        </Paper>
      </main>
    </>
  )
}

export default Checkout
